import { ww } from 'bobjoll/ts/library/dom';

export const isBannedCountry = () => {
    const bannedCountries = ['RU', 'UA', 'BY'];
    return ww.FeatureFlag.isEnabled('disable_affiliate_by_country') || bannedCountries.indexOf(USER_COUNTRY_CODE) != -1 ;
};
